import React from "react";
import { Calculator, Ruler, Wrench } from "lucide-react";

const Rule = ({ icon: Icon, title, children, testId }) => (
  <div className="flex gap-3 border-b border-slate-700/70 py-3 last:border-0" data-testid={testId}>
    <Icon className="mt-0.5 h-4 w-4 shrink-0 text-amber-400" />
    <div>
      <p className="text-sm font-semibold text-slate-100">{title}</p>
      <p className="mt-1 text-xs leading-5 text-slate-400">{children}</p>
    </div>
  </div>
);

export const ManufacturingMathCard = () => (
  <aside className="rounded-lg border border-slate-700 bg-slate-950/70 p-4" data-testid="manufacturing-math-card">
    <div className="mb-2 flex items-center gap-2">
      <Calculator className="h-4 w-4 text-sky-400" />
      <h3 className="font-semibold text-slate-100">Locked woodshop math</h3>
    </div>
    <Rule icon={Ruler} title="Materials" testId="manufacturing-rule-materials">
      Box core and shelving: 0.75&quot; / 19mm. Drawer boxes and full backs: 0.625&quot; / 16mm.
    </Rule>
    <Rule icon={Ruler} title="Cabinet heights" testId="manufacturing-rule-heights">
      Base: 30&quot;, or 29.125&quot; with 3cm countertop. Upper: 34&quot; at 96&quot; ceilings and 46&quot; at 108&quot; ceilings.
    </Rule>
    <Rule icon={Ruler} title="Panel scribe" testId="manufacturing-rule-panels">
      Applied panels and fridge gables receive exactly +1&quot; cut width and +1&quot; cut length.
    </Rule>
    <Rule icon={Wrench} title="Salice Progressa" testId="manufacturing-rule-hardware">
      Drawer width = cabinet interior width − 0.4375&quot;. Drawer height = door front height − 2.5&quot;.
    </Rule>
  </aside>
);